<div class="profile-container">
  @if (mode === 'final-user') {
    <div>
      <p class="m-0 p-0">{{ 'PROFILE.FINAL_USER' | translate }}</p>
    </div>
  }
  @if (avatar) {
    <img class="profile-image" [src]="avatar" alt="Profile Image" />
  } @else {
    <app-icam-icon [iconName]="'user'" class="profile-image" />
  }
  <div class="profile-info">
    <div>
      <span class="welcome-text">{{ 'HOME.WELCOME' | translate }} </span>
      <span class="username-text">{{ username | titlecase }}!</span>
    </div>

    @if (!isAdmin) {
      <div class="subtitle">
        {{ subtitle }}
      </div>
    }
  </div>
</div>
